import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FeatureCard = ({ title, description, icon, link, gradient, iconBg, iconColor }) => {
  return (
    <Link
      to={link}
      className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100 overflow-hidden"
    >
      {/* Gradient Background on Hover */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />

      {/* Content */}
      <div className="relative z-10">
        {/* Icon */}
        <div className={`${iconBg} w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
          <Icon name={icon} size={32} className={iconColor} />
        </div>

        {/* Title */}
        <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-cyan-600 transition-all duration-300">
          {title}
        </h3>

        {/* Description */}
        <p className="text-gray-600 text-base mb-4 leading-relaxed">
          {description}
        </p>

        {/* Arrow Icon */}
        <div className="flex items-center text-blue-600 font-semibold group-hover:gap-2 transition-all duration-300">
          <span>Keşfet</span>
          <Icon 
            name="ArrowRight" 
            size={20} 
            className="transform group-hover:translate-x-1 transition-transform duration-300" 
          />
        </div>
      </div>

      {/* Decorative Corner */}
      <div className={`absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-br ${gradient} rounded-full opacity-10 group-hover:opacity-20 transition-opacity duration-300`} />
    </Link>
  );
};

export default FeatureCard;